import Vue from "vue";
import moment from "moment";

export default ({ folio, expected_delivery_date: date }) => {
  const payload = {
    delivery_date: moment(date).locale("es").format(),
  };
  return Vue.$http
    .put(`purchase/warehouse/delivery_date/${folio}/`, payload)
    .then((response) => response.data);
};



// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/updateDeliveryDateODC.js